var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-fields" },
    [
      _c("popular-search-destination", {
        attrs: {
          value: _vm.selectedDestinationAirport,
          validation: _vm.validation,
          "show-selector": _vm.showSelector,
          "open-modal": _vm.openModal,
          "show-custom-destinations": true,
          departureAirport: _vm.form.departureAirport
        },
        on: {
          input: _vm.selectDestinationAirport,
          hide: function($event) {
            _vm.showSelector = null
          },
          show: function($event) {
            _vm.showSelector = "destination-selector"
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-field search-dates" },
        [
          _c("input-field", {
            ref: "fromDate",
            attrs: {
              name: _vm.translations.travel_dates,
              readonly: true,
              "icon-type": "calendar",
              value: _vm.dateString,
              error: _vm.validation.fromDate || _vm.validation.toDate
            },
            on: {
              click: function($event) {
                _vm.showSelector = "calendar"
                _vm.dateSelection = "FROM_DATE"
              }
            }
          }),
          _vm._v(" "),
          _vm.showSelector == "calendar"
            ? _c("skov-range-picker", {
                ref: "calendar",
                attrs: {
                  value: _vm.initRange,
                  "use-noscroll": _vm.useNoscroll,
                  showDateInputs: false
                },
                on: { close: _vm.closeCalendar, input: _vm.selectDates }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-field search-field--travelers" },
        [
          _c("input-field", {
            attrs: {
              name: _vm.translations.number_of_travelers,
              value: _vm.numberOfTravelers,
              readonly: true,
              "icon-type": "travelers",
              error: _vm.validation.adults || _vm.validation.children
            },
            on: {
              focus: function($event) {
                _vm.showSelector = "travelers"
              }
            }
          }),
          _vm._v(" "),
          _vm.showSelector == "travelers"
            ? _c(
                "modal",
                {
                  staticClass: "modal--search-widget",
                  attrs: {
                    title: _vm.translations.number_of_travelers,
                    "close-on-click": true,
                    "is-open": _vm.openModal == "travelers"
                  },
                  on: {
                    close: function($event) {
                      _vm.showSelector = null
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      slot: "icon",
                      src: require("../../../../../assets/img/icons/icon-persons.svg"),
                      alt: ""
                    },
                    slot: "icon"
                  }),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass: "modal-view-list modal-view-list--no-hover"
                    },
                    [
                      _c(
                        "li",
                        { staticClass: "modal-view-list__item" },
                        [
                          _c("span", {
                            staticClass: "modal-view-list__item__text",
                            domProps: {
                              textContent: _vm._s(
                                _vm.translations.number_of_adults
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("count-picker", {
                            attrs: { max: 4, min: 0 },
                            model: {
                              value: _vm.form.adults,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "adults", $$v)
                              },
                              expression: "form.adults"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "modal-view-list__item" },
                        [
                          _c("span", {
                            staticClass: "modal-view-list__item__text",
                            domProps: {
                              textContent: _vm._s(
                                _vm.translations.number_of_children
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("count-picker", {
                            attrs: { min: 0, max: 4 },
                            model: {
                              value: _vm.form.childrenCount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "childrenCount", $$v)
                              },
                              expression: "form.childrenCount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.form.children, function(val, key) {
                        return _c(
                          "li",
                          { key: key, staticClass: "modal-view-list__item" },
                          [
                            _c("span", {
                              staticClass: "modal-view-list__item__text",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.translations.children_ages.replace(
                                    /{n}/,
                                    key + 1
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("count-picker", {
                              attrs: {
                                min: -1,
                                placeholder: _vm.translations.age,
                                max: _vm.maxChildrenAge
                              },
                              model: {
                                value: _vm.form.children[key],
                                callback: function($$v) {
                                  _vm.$set(_vm.form.children, key, $$v)
                                },
                                expression: "form.children[key]"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c("li", { staticClass: "modal-view-list__item" }, [
                        _c("a", {
                          staticClass: "modal-view-list__item__link",
                          attrs: {
                            href: "/vigtig-information/grupperejsebestilling"
                          },
                          domProps: {
                            textContent: _vm._s(_vm.translations.grouptravel)
                          }
                        })
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "modal-view__footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c("button", {
                        staticClass: "btn btn--success",
                        attrs: {
                          disabled:
                            _vm.validForm &&
                            (_vm.validForm.children || _vm.validForm.adults)
                        },
                        domProps: {
                          textContent: _vm._s(_vm.translations.ok_btn)
                        },
                        on: {
                          click: function($event) {
                            _vm.showSelector = null
                          }
                        }
                      })
                    ]
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-with-icon btn--positive search-fields__btn",
          attrs: { disabled: _vm.validForm },
          on: { click: _vm.search }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 19.95 19.95"
              }
            },
            [
              _c("path", {
                staticStyle: { fill: "#fff", "fill-rule": "evenodd" },
                attrs: {
                  d:
                    "m19.55,17.53l-3.77-3.77c.93-1.42,1.37-3.19,1.37-5.18,0-2.55-.72-4.74-2.28-6.3-1.56-1.55-3.75-2.28-6.3-2.28S3.83.72,2.28,2.28C.72,3.83,0,6.02,0,8.58s.72,4.74,2.28,6.3c1.56,1.55,3.75,2.28,6.3,2.28,1.99,0,3.76-.44,5.18-1.37l3.77,3.77c.27.26.63.4,1,.4.37,0,.73-.15,1-.42.26-.26.42-.62.42-1,0-.37-.14-.74-.4-1Zm-6.69-4.67c-.88.87-2.25,1.44-4.28,1.44s-3.4-.56-4.28-1.44-1.44-2.25-1.44-4.28.56-3.4,1.44-4.28c.87-.88,2.25-1.44,4.28-1.44s3.4.56,4.28,1.44c.87.87,1.44,2.25,1.44,4.28s-.56,3.4-1.44,4.28Z"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("span", {
            domProps: { textContent: _vm._s(_vm.translations.search) }
          })
        ]
      ),
      _vm._v(" "),
      _vm.showSelector == "group-travel"
        ? _c(
            "modal",
            {
              staticClass: "modal-view--bg modal-view--group-travel",
              attrs: {
                title: "Grupperejsebestilling",
                "is-open": _vm.openModal == "group-travel"
              },
              on: {
                close: function($event) {
                  _vm.showSelector = null
                }
              }
            },
            [
              _c(
                "svg",
                {
                  staticClass: "icon-person",
                  attrs: {
                    slot: "icon",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 511.18 490.04"
                  },
                  slot: "icon"
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M187.83,490c-44.06-.32-79.51-1.42-114.53-8.06-16.73-3.17-33.16-7.4-48.23-15.71C8.75,457.27.19,444.48,0,424.83c-.21-21.56,11.12-35.61,25.83-48.29,20.79-17.91,45-30.12,69.93-41.1,4.57-2,9.12-4.19,13.9-5.53,8.62-2.41,13.8-8.24,17.51-15.87A42.14,42.14,0,0,0,129,280.57c-.73-2.09-2.42-3.93-3.91-5.67C96.59,241.43,81,203,81.59,158.77c.32-25.36,7.35-48.77,24.82-67.92,21.2-23.23,48.34-31.89,79-29.4,32.18,2.61,57.94,17.15,74.54,45.41,13.34,22.71,16.26,47.73,12.73,73.46-5,36.2-20.7,67.49-44.65,94.86a18.74,18.74,0,0,0-3.85,7.33c-3.6,13.69-3.61,27.16,4.83,39.29a18.61,18.61,0,0,0,8.39,6.44c29.36,10.71,57.72,23.31,83,42.07,10.08,7.49,19.13,16,26,26.7,14.23,22.06,7.59,53.21-14.48,67.19-15.63,9.9-33.2,14.53-51.12,17.66-14.41,2.52-29,4.54-43.56,5.7C217.94,489.08,198.61,489.53,187.83,490Z",
                      transform: "translate(0 0)"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "M264.52,296c9.67-16.23,20.19-31.52,28.32-48,19.06-38.58,25.93-79.26,16.62-121.85-6-27.29-19.11-50.62-39.86-69.5-1.23-1.12-2.43-2.27-3.65-3.41a7.06,7.06,0,0,1-.51-.85c8-20.13,21.34-35.95,41.78-44.21,34.6-14,67.46-10.75,96.16,14.36,17.8,15.57,25.73,36.72,27.52,59.82,3.48,44.91-9.28,84.89-38.46,119.42-5.29,6.25-7.79,22.53-3.24,29.32a23,23,0,0,0,10.74,8.07c20.68,7.58,41,16,59.94,27.19,16.27,9.63,31.76,20.26,42.74,36.18,16.08,23.29,8.83,53.81-16.07,67.22-18.8,10.13-39.36,14.23-60.21,17.05-11.71,1.59-23.52,2.46-35.31,3.34-1.61.12-4.27-1.19-4.9-2.55-9.89-21.59-26.14-37.58-44.89-51.35-21.35-15.67-44.9-27.31-69.35-37.23C269.12,298,266.37,296.8,264.52,296Z",
                      transform: "translate(0 0)"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("group-travel")
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17f6760f", { render: render, staticRenderFns: staticRenderFns })
  }
}